import { ArrowUpRight, Check, MessageCircle } from "lucide-react";
import Reveal from "./Reveal";
import { FORM_URL, SERVICES, WHATSAPP_MSG_URL } from "./data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-slate-50 py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sapphire">What we do</p>
            <h2 className="mt-3 max-w-xl text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Five specialist services, one spotless result
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-slate-500 sm:text-base">
            Every service includes trained crew, professional machines, eco-safe chemicals and a post-job quality audit.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08} className="h-full">
              <article
                data-testid={s.testId}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-shadow duration-500 hover:shadow-xl"
              >
                <div className="img-zoom h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" className="h-full w-full object-cover" />
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sapphire-light text-sapphire">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <h3 className="text-lg font-bold tracking-tight text-slate-900 sm:text-xl">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                  <ul className="mt-4 space-y-2">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm text-slate-600">
                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-whatsapp" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <a
                    data-testid={`${s.testId}-book-link`}
                    href={FORM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto inline-flex items-center gap-1 pt-5 text-sm font-bold text-sapphire transition-colors hover:text-sapphire-dark"
                  >
                    Book this service
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.16} className="h-full">
            <div className="flex h-full flex-col justify-between rounded-3xl bg-sapphire p-8 text-white shadow-xl shadow-sapphire/25">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/70">Custom requirement?</p>
                <h3 className="mt-3 text-2xl font-bold tracking-tight">
                  Tell us about your space — get a free quote today
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/80">
                  Water tanks, facades, event cleanups or annual facility contracts — if it needs cleaning, we have a
                  plan for it.
                </p>
              </div>
              <a
                data-testid="services-custom-whatsapp-button"
                href={WHATSAPP_MSG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-whatsapp px-6 py-3 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-whatsapp-dark"
              >
                <MessageCircle className="h-4 w-4" />
                Get free quote on WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
